// extracted by mini-css-extract-plugin
module.exports = {"dateSpan":"qft3lNV1","styledPriceDisplay":"d1OxthOX","horizontalView":"xDawJqrL","hidePricePercentage":"HgQOi9aR","showDotSeparator":"pHXTOQ4q"};